exports.createPaginationPages = ({
  basePath,
  component,
  createPage,
  itemCount,
  perPage,
  context,
  initialSkip = 0,
}) => {
  const pageCount = itemCount === 0 ? 1 : Math.ceil(itemCount / perPage)

  for (let currentPage = 1; currentPage <= pageCount; currentPage++) {
    const pageUrl = currentPage === 1 ? basePath : `${basePath}page/${currentPage}/`
    createPage({
      path: pageUrl,
      component,
      context: {
        // Variables for GraphQL query:
        limit: perPage,
        skip: initialSkip + perPage * (currentPage - 1),
        pageUrl,
        // Pagination information, links
        pageCount,
        basePath,
        currentPageNumber: currentPage,
        previousPage: currentPage > 1 ? pageURL(currentPage - 1) : null,
        previousPageNumber: currentPage > 1 ? currentPage - 1 : null,
        nextPage: currentPage < pageCount ? pageURL(currentPage + 1) : null,
        nextPageNumber: currentPage < pageCount ? currentPage + 1 : null,
        ...context,
      },
    })
  }
}

const pageURL = ({ basePath, page }) => (page === 1 ? basePath : `${basePath}page/${page}/`)

exports.pageURL = pageURL
